<template>
    <div>
        <v-overlay v-if="!isCartItemsLoaded" absolute style="background-color: rgba(20, 20, 20, 0.4)" :value="true">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!-- <div v-if="serieApplied" class="alert alert-success d-flex align-items-center" role="alert">
            <div class="flex-shrink-0">
                <i class="fa fa-fw fa-check"></i>
            </div>
            <div class="flex-grow-1 ms-3">
                <p class="mb-0">
                    {{ $t('cart.item_types.subscription') }} appliqué ! : <b>{{ serieApplied.name }}</b>
                </p>
            </div>
        </div>
        <div v-if="treatmentApplied" class="alert alert-success d-flex align-items-center" role="alert">
            <div class="flex-shrink-0">
                <i class="fa fa-fw fa-check"></i>
            </div>
            <div class="flex-grow-1 ms-3">
                <p class="mb-0">
                    {{ $t('cart.item_types.package') }} appliquée ! : <b>{{ treatmentApplied.name }}</b>
                </p>
            </div>
        </div> -->
        <!-- dj -->
        <div v-if="showAlertPrepaid" class="alert alert-danger d-flex align-items-center" role="alert">
            <div class="flex-shrink-0">
                <i class="fa fa-fw fa-info"></i>
            </div>
            <div class="flex-grow-1 ms-3">
                <p class="mb-0">{{ $t('cart.alerts.select_prepayment') }}</p>
            </div>
        </div>
        <div v-if="isClotured" class="alert alert-danger d-flex align-items-center" role="alert">
            <div class="flex-shrink-0">
                <i class="fa fa-fw fa-info"></i>
            </div>
            <div class="flex-grow-1 ms-3">
                <p class="mb-0">{{ $t('cart.alerts.sale_clotured') }}</p>
            </div>
        </div>

        <div class="content-box px-0 w-100 mb-3" style="min-height: 332px">
            <div class="block-header px-4">
                <h3
                    class="block-title py-1 ppv2-text-black mb-3"
                    style="
                        font-size: clamp(12px, 0.729545vw, 16px) !important;
                        border-bottom: 1px solid #7d2dbd;
                        padding-bottom: 15px;
                    "
                >
                    {{ $t('cart.title') }} ({{ Object.keys(c_cartItems).length }} )
                </h3>
            </div>
            <div class="panierTable">
                <table class="table-borderless table-hover table-vcenter w-100 mb-3">
                    <thead>
                        <tr class="border-bottom-dark-blue">
                            <th class="text-end fw-normal fs-sm ppv2-text-black text-nowrap">{{ $t('cart.columns.qty') }}</th>
                            <th class="text-center fw-normal fs-sm ppv2-text-black text-nowrap">
                                {{ $t('cart.columns.designation') }}
                            </th>
                            <th class="text-center fw-normal fs-sm ppv2-text-black text-nowrap">
                                {{ $t('cart.columns.unit_price') }}
                            </th>
                            <th class="d-flex fw-normal justify-content-end text-nowrap" style="padding-right: 0px !important">
                                {{ $t('cart.columns.total_ttc') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="Object.keys(c_cartItems).length > 0">
                        <tr v-for="item in c_cartItems" :key="item.id" id="articles_id" class="rounded border-bottom">
                            <td style="padding-left: 0px !important">
                                <div class="d-flex align-items-center justify-content-between gap-2">
                                    <a
                                        v-if="!item.bookingId && (canDeleteOrder === true || canDeleteOrder === 'true')"
                                        style="margin-right: 10px"
                                        class="text-muted"
                                        :href="`/back-office/caisse/${item.rowId}/delete`"
                                    >
                                        <svg
                                            width="18"
                                            height="18"
                                            viewBox="0 0 25 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M3.5 6H21.5"
                                                stroke="#94A3B8"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M19.5 6V20C19.5 21 18.5 22 17.5 22H7.5C6.5 22 5.5 21 5.5 20V6"
                                                stroke="#94A3B8"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M8.5 6V4C8.5 3 9.5 2 10.5 2H14.5C15.5 2 16.5 3 16.5 4V6"
                                                stroke="#94A3B8"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M10.5 11V17"
                                                stroke="#94A3B8"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M14.5 11V17"
                                                stroke="#94A3B8"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </a>
                                    <a v-else
                                        ><svg
                                            width="25"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
                                                stroke="#021832"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
                                                stroke="#021832"
                                                stroke-width="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                    </a>
                                    <span>{{ item.qty }} </span>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex align-center justify-content-center">
                                    <div class="h6 text-nowrap fs-5" style="margin-bottom: 0px">
                                        <!-- {{ item.qty }} x {{ item.name }} <span v-if="item.is_ticket">{{ item.ticketInfo }}</span>-->
                                        {{ item.name }} <span v-if="item.is_ticket">{{ item.ticketInfo }}</span>
                                        <span class="text-muted" v-if="item.timeSlot && item.timeSlot.start">
                                            / {{ formatTime(item.timeSlot.start) }}
                                        </span>
                                    </div>

                                    <template v-if="item.voucherCode">
                                        <v-icon small style="margin-left: 20px; margin-right: 5px">mdi-gift</v-icon
                                        >{{ item.voucherCode }}
                                        <div v-if="item.voucherCode" class="h6 fs-5 text-nowrap" style="margin-left: 20px"></div>
                                    </template>

                                    <div class="d-flex">
                                        <span v-if="item.options.serie" class="text-success d-block d-inline">{{
                                            $t('cart.item_types.subscription')
                                        }}</span>
                                        <span v-if="item.options.treatment" class="text-warning d-block d-inline">{{
                                            $t('cart.item_types.package')
                                        }}</span>
                                    </div>
                                </div>
                                <div v-if="item">
                                    <b class="seller d-flex justify-content-center">
                                        <button
                                            class="ms-2"
                                            type="button"
                                            @click="openStaffModal(item.id, item.advised.id, item.seller.id)"
                                        >
                                            <span style="margin-right: 5px">
                                                <i class="far fa-address-book text-primary"></i>
                                                <span v-if="item.seller">{{ item.seller.first_name }}</span>
                                                <span v-else>{{ '@n/a' }}</span>
                                            </span>
                                            <span>
                                                <i class="far fa-comment-dots text-primary"></i>
                                                <span v-if="item.advised">{{ item.advised.first_name }}</span>
                                                <span v-else>{{ '@n/a' }}</span>
                                            </span>
                                        </button>
                                    </b>
                                    <div v-if="item.code" class="d-flex justify-content-center" style="flex-wrap: wrap">
                                        <div class="mt-2 mx-1" v-for="(val, index) of item.code" :key="index">
                                            <v-chip
                                                @click="
                                                    () => {
                                                        if (canModifyOrder === true || canModifyOrder === 'true') {
                                                            val.enable = !val.enable
                                                        }
                                                    }
                                                "
                                                color="red"
                                                label
                                                text-color="white"
                                                dense
                                                active
                                                style="height: 25px; cursor: pointer"
                                                :set="
                                                    (noComplete =
                                                        c_promoCodeNoCompleteUsed &&
                                                        c_promoCodeNoCompleteUsed.find(
                                                            (x) => x.codeId == val.id && item.rowId == x.itemKey
                                                        ))
                                                "
                                            >
                                                <v-icon left small> mdi-ticket-percent </v-icon>
                                                <span
                                                    :style="val.enable ? '' : 'text-decoration: line-through'"
                                                    v-if="noComplete"
                                                >
                                                    {{ val.title }} --
                                                    {{ noComplete.used.toFixed(2) }}
                                                    /
                                                    {{ noComplete.amount.toFixed(2) }}
                                                    {{ $symbolCurrency }}
                                                </span>
                                                <span v-else :style="val.enable ? '' : 'text-decoration: line-through'">
                                                    {{ val.title }} -- {{ val.amount }}
                                                </span>
                                            </v-chip>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-end">
                                <div class="d-flex align-items-center fw-normal justify-content-center">
                                    <span
                                        style="text-decoration: line-through"
                                        v-if="item._oldPrice && item._oldPrice != item.price"
                                        >{{ item._oldPrice }}{{ $symbolCurrency }}</span
                                    >
                                    <span class="ms-2 text-primary"
                                        >{{ parseFloat(item.price).toFixed(2) }}{{ $symbolCurrency }}</span
                                    >
                                </div>
                            </td>
                            <td class="text-end" style="padding-right: 0px !important">
                                <div class="d-flex align-items-center fw-semibold justify-content-end">
                                    <span class="ms-2 text-primary">
                                        {{ (item.price * item.qty).toFixed(2) }}{{ $symbolCurrency }}</span
                                    >
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td class="text-center" colspan="6">
                                <span class="text-muted fs-xs">{{ $t('cart.empty') }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="block rounded-12 content-box w-100 mb-0 py-2 content-box-enc">
            <div class="block-content overflow-auto mb-0 pt-0" style="max-height: 100%; display: grid">
                <!-- <h3
                    class="block-title ps-0 ppv2-text-black"
                    style="font-size: clamp(12px, 0.729545vw, 16px) !important; border-bottom: 1px solid #7D2DBD; padding-bottom: 15px"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        class="ml-1 me-1 bi bi-credit-card"
                        viewBox="0 0 16 16" style="margin-top: -5px;">
                        <path
                            d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"
                        />
                        <path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z" />
                    </svg>

                    Paiement
                </h3>-->
                <div class="d-flex justify-content-between align-content-center rounded mt-0 w-100" style="margin: auto">
                    <div class="d-flex flex-column w-100" style="flex: 1">
                        <v-simple-table>
                            <template v-slot:default>
                                <tbody>
                                    <!-- Total panier -->
                                    <!--<tr>
                                        <td class="fs-sm poppinsMedium" style="border-bottom: 0 !important">Montant du panier :</td>
                                        <td class="h6 text-nowrap" style="border-bottom: 0 !important; text-align: right">
                                            {{ Math.round((c_remainAfterGlobalPromoCode + Number.EPSILON) * 100) / 100 }}{{$symbolCurrency}}
                                        </td>
                                    </tr>-->

                                    <!-- Payment -->

                                    <template v-for="(val, index) of c_payments">
                                        <tr :key="index" v-if="val && parseFloat(val.value)">
                                            <td class="ps-0">{{ val.display_name }}</td>
                                            <td class="text-end text-amethyst fw-bold pe-0">
                                                {{ val.value }}{{ $symbolCurrency }}
                                            </td>
                                        </tr>
                                    </template>

                                    <!-- Accompte -->
                                    <tr v-if="c_order && c_order.invoices && c_order.invoices?.length">
                                        <td class="ps-0">{{ $t('cart.payment.acompte') }}</td>
                                        <td class="text-end text-amethyst fw-bold pe-0 text-nowrap">
                                            {{
                                                (
                                                    c_order.invoices.reduce(
                                                        (prev, current) => prev + (parseFloat(current.amount) || 0),
                                                        0
                                                    ) || 0
                                                ).toFixed(2)
                                            }}
                                            {{ $symbolCurrency }}
                                        </td>
                                    </tr>

                                    <!-- Point de fidelité -->
                                    <tr v-if="c_establishment?.is_loyalty_program_enabled && usedFidelityPoints">
                                        <td class="ps-0">{{ $t('cart.fidelity.discount') }} ({{ usedFidelityPoints }} pts)</td>
                                        <td class="text-end text-amethyst fw-bold pe-0 text-nowrap">
                                            {{
                                                parseFloat(
                                                    usedFidelityPoints / (c_establishment?.fidelity_points_trans || 10)
                                                ).toFixed(2)
                                            }}{{ $symbolCurrency }}
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>

                        <div
                            v-if="accompte != 0"
                            class="block-content block-content-full bg-white rounded mb-2 d-flex flex-column w-100"
                        >
                            <span class="h6 fw-medium my-auto mb-1">{{ $t('cart.payment.acompte_and_rest') }}</span>
                            <span v-if="totalAccompte != 0" class="text-warning fw-bold my-auto"
                                >{{ $t('cart.payment.acompte_to_pay') }} {{ totalAccompte }}{{ $symbolCurrency }}</span
                            >
                            <span v-if="rest != 0" class="text-success fw-bold my-auto">
                                {{ $t('cart.payment.already_paid') }}
                                {{ parseFloat(rest).toFixed(2) }}
                                {{ $symbolCurrency }}
                            </span>
                            <span v-if="rest != 0" class="text-primary fw-bold my-auto">
                                {{ $t('cart.payment.rest_to_pay') }}
                                {{ parseFloat(totalWRest).toFixed(2) }}
                                {{ $symbolCurrency }}
                            </span>
                        </div>
                    </div>
                </div>

                <input
                    v-for="(val, index) of c_voucherUsed"
                    type="hidden"
                    name="voucher-used[]"
                    :value="stringify(val)"
                    :key="index"
                />

                <input
                    v-for="(val, index) of prepaidTreatment"
                    type="hidden"
                    name="prepaid-treatment[]"
                    :key="'p' + index"
                    :value="stringify(val)"
                />
                <input
                    v-for="(val, index) of prepaidSerie"
                    type="hidden"
                    name="prepaid-serie[]"
                    :key="'p' + index"
                    :value="stringify(val)"
                />
                <template v-if="c_establishment?.is_loyalty_program_enabled">
                    <label class="form-label mt-1 mb-2"> {{ $t('cart.fidelity.points') }} </label>
                    <div
                        v-if="c_customer && c_customer.customer && c_customer.customer.loyalty_points !== undefined"
                        class="block-content block-content-ful mb-4 pt-0"
                    >
                        <!-- @input="
                                        (val) => {
                                            if (!isNaN(usedFidelityPoints) && parseInt(usedFidelityPoints) > maxFidelityPoint)
                                                usedFidelityPoints = `${maxFidelityPoint}`
                                            else usedFidelityPoints = 0
                                        }
                                    " -->
                        <div class="d-flex flex-column">
                            <div class="d-flex mb-2" style="height: 42px">
                                <input
                                    type="number"
                                    class="form-control disable-focus fidelity-desg"
                                    name="fidelity_points"
                                    id="fidelity_points"
                                    min="0"
                                    :max="`${maxFidelityPoint}`"
                                    step="1"
                                    v-model="usedFidelityPoints"
                                    @input="
                                        (e) => {
                                            usedFidelityPoints = Math.floor(parseFloat(e.target.value) || 0)
                                        }
                                    "
                                    :disabled="
                                        isNaN(parseFloat(c_customer.customer.loyalty_points)) ||
                                        c_customer.customer.loyalty_points == 0 ||
                                        !(canModifyOrder === true || canModifyOrder === 'true')
                                    "
                                />
                                <div class="p-2 fw-normal px-3 euro-desg">
                                    {{ parseFloat(usedFidelityPoints / (c_establishment?.fidelity_points_trans || 10)).toFixed(2)
                                    }}{{ $symbolCurrency }}
                                </div>
                            </div>
                            <div class="fs-xs fw-normal" style="color: #7d2dbd; margin-top: 12px">
                                {{ $t('cart.fidelity.remaining') }}
                                <b>{{ c_customer.customer.loyalty_points - (usedFidelityPoints || 0) }}</b>
                                <i class="fas fa-coins"></i>
                            </div>
                        </div>
                    </div>
                </template>
                <div v-if="c_promoCodes && c_promoCodes.length > 0" class="d-flex justify-content-center">
                    <div class="some-amount">
                        <p class="title-some-am fs-6 fw-medium ppv2-text-black mb-1 pb-1">{{ $t('cart.payment.promo_code') }}</p>
                        <div v-for="(code, i) in c_promoCodes" :key="i" class="pb-0 d-flex justify-content-between">
                            <div>
                                <p class="fw-normal ppv2-text-black fs-6 mb-1 pe-3">
                                    {{ code.title }} - {{ code.code }}
                                    <!--<span class="box-amount"
                                >-{{ code.discount_amount }}{{ code.discount_type == 'percentage' ? '%' : '{{$symbolCurrency}}' }}</span
                            >-->
                                </p>
                                <!-- <p class="fw-normal ppv2-text-black fs-6 mb-0">
                                    {{ code.description }}
                                </p> -->
                            </div>
                            <div class="d-flex flex-nowrap align-items-baseline">
                                <span class="box-amount"
                                    >-{{ code.discount_amount
                                    }}{{ code.discount_type == 'percentage' ? '%' : $symbolCurrency }}</span
                                >
                                <a @click="deleteCode(i)" style="cursor: pointer"
                                    ><svg
                                        width="25"
                                        height="24"
                                        viewBox="0 0 25 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M3.5 6H21.5"
                                            stroke="#94A3B8"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M19.5 6V20C19.5 21 18.5 22 17.5 22H7.5C6.5 22 5.5 21 5.5 20V6"
                                            stroke="#94A3B8"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M8.5 6V4C8.5 3 9.5 2 10.5 2H14.5C15.5 2 16.5 3 16.5 4V6"
                                            stroke="#94A3B8"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M10.5 11V17"
                                            stroke="#94A3B8"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M14.5 11V17"
                                            stroke="#94A3B8"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-between band-total mb-2">
                    <p class="fs-6 fw-medium text-white mb-0">{{ $t('cart.payment.total_ttc') }}</p>
                    <span class="fs-6 fw-medium text-white">
                        {{ Math.round((c_remainAfterGlobalPromoCode + Number.EPSILON) * 100) / 100 }} {{ $symbolCurrency }}
                    </span>
                </div>
            </div>
        </div>

        <div :class="Object.values(staffModalData).every((s) => s !== null) ? 'd-block' : 'd-none'">
            <staff-modal
                v-if="staffModalData.cartRowId && staffModalData.adviserId && staffModalData.sellerId"
                :cartRowId="staffModalData.cartRowId"
                :adviserId="staffModalData.adviserId"
                :sellerId="staffModalData.sellerId"
                @hide-staff-modal="hideStaffModal"
            ></staff-modal>
        </div>
        <close-sale-modal
            v-if="showModalCloseSale"
            :closeSaleModal="showModalCloseSale"
            :companyName="company_name"
            :companyAddress="company_address"
            :parameterThanks="parameterThanks"
            :sendInvoice="sendInvoice"
            :sendMail="sendMail"
            @close-sale="hideCloseSaleModal"
            @close-sale-modal="closeSaleModal"
        ></close-sale-modal>
    </div>
</template>

<script>
import moment from 'moment'
import { sync, get } from 'vuex-pathify'
import StaffModal from './StaffModal.vue'
import PaymentRefound from './PaymentRefound.vue'
import FingerprintChange from './FingerprintChange.vue'
import axios from 'axios'
import CloseSaleModal from './CloseSaleModal.vue'

export default {
    components: { StaffModal, PaymentRefound, FingerprintChange, CloseSaleModal },
    props: [
        'accompte',
        'rest',
        'totalAccompte',
        'totalWithDiscount',
        'cartTotal',
        'promoCode',
        'saveBasketRoute',
        'orderId',
        'walletTransaction',
        'isClotured',
        'orderObj',
        'canCreateOrder',
        'canModifyOrder',
        'canDeleteOrder',
    ],
    data: () => ({
        closeSale: false,
        showModalThanks: false,
        showModalCloseSale: false,
        usedFidelityPoints: 0,
        isPrepaid: false,
        staffModalData: { cartRowId: null, adviserId: null, sellerId: null },
        parameterThanks: {
            rebooking: false,
            notice: false,
        },
        invoices: [],
        company_name: null,
        company_address: {
            address: null,
            cp: null,
            country: null,
        },
        sendInvoice: false,
        sendMail: false,
    }),
    created() {
        this.sendInvoice = this.orderObj && this.orderObj.send_invoice
        this.sendMail = false
        this.company_name = this.orderObj && this.orderObj.company_name
        if (this.orderObj && this.orderObj.company_address) {
            const full_address = this.orderObj.company_address.split('_')
            this.company_address.address = full_address[0]
            this.company_address.cp = full_address[1]
            this.company_address.country = full_address[2]
        }
    },
    computed: {
        ...get('overlay@data', {
            c_remainPrice: 'remainPrice',
            c_payments: 'payments',
            c_customer: 'customer',
            c_establishment: 'establishment',
            c_prepaidPrestations: 'prepaidPrestations',
            c_promoCodes: 'promoCodes',
            c_customDiscount: 'customDiscount',
            c_order: 'order',
            c_remainBeforeGlobalPromoCode: 'remainBeforeGlobalPromoCode',
            c_remainAfterGlobalPromoCode: 'remainAfterGlobalPromoCode',
            c_promoCodeNoCompleteUsed: 'promoCodeNoCompleteUsed',
            c_voucherUsed: 'voucherUsed',
        }),
        ...sync('overlay@data', {
            c_cartItems: 'cartItems',
            c_promoCodes: 'promoCodes',
        }),
        maxFidelityPoint() {
            return this.c_customer?.customer?.loyalty_points || 0
        },
        showAlertPrepaid() {
            var isPrepaid = false
            var isPrepaidApplied = false
            if (this.c_cartItems && this.c_prepaidPrestations) {
                const serieItems = Object.values(this.c_cartItems).filter((x) => x.options.serie)
                const treatmentItems = Object.values(this.c_cartItems).filter((x) => x.options.treatment)

                if (serieItems?.length > 0 || treatmentItems?.length > 0) {
                    this.isPrepaid = true
                    return true
                }
                if (this.c_prepaidPrestations?.length > 0) {
                    isPrepaidApplied = true
                } else {
                    isPrepaidApplied = false
                }

                if (this.isPrepaid && isPrepaidApplied) {
                    return false
                }
            }

            return false
        },
        prepaidTreatment() {
            if (this.c_prepaidPrestations)
                return this.c_prepaidPrestations
                    .filter((x) => x.prepaid.type == 'treatment')
                    .map((x) => {
                        return {
                            orderItem: x.prestation.id,
                            userTreatment: x.prepaid.pivot.id,
                            quantity: x.qty,
                        }
                    })
        },
        prepaidSerie() {
            if (this.c_prepaidPrestations)
                return this.c_prepaidPrestations
                    .filter((x) => x.prepaid.type == 'serie')
                    .map((x) => {
                        return {
                            orderItem: x.prestation.id,
                            userSerie: x.prepaid.pivot.id,
                            quantity: x.qty,
                        }
                    })
        },
        isCartItemsLoaded() {
            return this.c_cartItems && Object.keys(this.c_cartItems).length > 0
        },
    },
    methods: {
        console() {
            return console
        },
        getVoucherCode(id) {
            return axios.get(`/back-office/caisse/getVoucherCode/${id}`).then((res) => res.data)
        },
        stringify(val) {
            return JSON.stringify(val)
        },
        parseDate(date, format) {
            return moment(date).locale(this.$i18n.locale).format(format)
        },
        getValueOfDate(date) {
            return moment(date).valueOf()
        },
        totalAmountGlobalRemise(codes) {
            let price = parseFloat(this.c_remainBeforeGlobalPromoCode).toFixed(2)
            const old = price
            if (codes && codes.find((x) => x.is_global || x.is_voucher)) {
                codes.forEach((t) => {
                    if (!t.is_global || !t.is_voucher) return

                    price -= this._computeAmountCodePromo(price, t)
                })
            }
            return { old: old, new: price }
        },
        _computeAmountCodePromo(amount, currentCode) {
            let res = 0
            if (currentCode.discount_type == 'fixed') {
                res = amount > currentCode.discount_amount ? currentCode.discount_amount : amount
            } else if (currentCode.discount_type == 'percentage') {
                res = amount * (currentCode.discount_amount / 100)
            }
            return res
        },
        submitForm() {
            if (this.c_remainPrice == 0 && this.closeSale == false) {
                //this.closeSale = true
                this.showModalCloseSale = true
            } else {
                this.$emit('submit-form')
            }
        },
        openStaffModal(cartRowId, adviserId, sellerId) {
            this.staffModalData = {
                cartRowId: cartRowId,
                adviserId: adviserId,
                sellerId: sellerId,
            }
        },
        hideStaffModal() {
            Object.keys(this.staffModalData).forEach((key) => {
                this.staffModalData[key] = null
            })
        },
        hideCloseSaleModal(data) {
            this.closeSale = data.close_sale
            this.company_name = data.company_name
            this.company_address = data.company_address
            this.parameterThanks.rebooking = data.rebooking
            this.parameterThanks.notice = data.notice
            this.showModalCloseSale = false
            this.sendMail = data.send_mail
            this.sendInvoice = data.send_invoice

            setTimeout(() => {
                this.$emit('submit-form')
            }, 300)
        },
        closeSaleModal() {
            this.closeSale = false
            this.showModalCloseSale = false
        },
        deleteCode(index) {
            this.$emit('delete-code', index)
        },
        formatTime(timestamp) {
            if (!timestamp) return this.$t('common.no_date')

            const date = moment(timestamp, moment.ISO_8601, true).isValid() ? moment(timestamp) : moment.unix(Number(timestamp))

            if (!date.isValid()) {
                return this.$t('common.invalid_date')
            }

            return date.locale(this.$i18n.locale).format('D MMM YYYY HH:mm')
        },
    },
    watch: {
        c_remainPrice(val) {
            if (this.closeSale && val !== '0.00') {
                this.closeSale = false
            }
        },
        usedFidelityPoints(newVal) {
            this.$emit('used-fidelity-points', newVal)
        },

        async 'c_order.invoices'(val) {
            if (!val) return

            const copy = []
            for (let i = 0; i < val?.length; i++) {
                const elem = val[i]
                if (elem.voucher_id) elem.voucher = await this.getVoucherCode(elem.voucher_id)
                copy.push(elem)
            }
            this.invoices = copy.reverse()
        },
        // sendInvoice(newVal) {
        //     if(newVal == false) {
        //         this.company_name = null
        //         this.company_address = {
        //             address: null,
        //             cp: null,
        //             country: null,
        //         }
        //     }
        // },
        // sendMail(newVal) {
        //     if(newVal == false) {
        //         this.parameterThanks = {
        //             rebooking: false,
        //             notice: false,
        //         }
        //     }
        // }
    },
}
</script>

<style scoped>
.disable-focus:focus {
    border-color: none !important;
    box-shadow: none !important;
}
.theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: transparent !important;
}
</style>
<style scoped>
#promo-code-select {
    margin: 15px 0px;
    width: 100%;
}
select#promo-code-select {
    height: 40px;
    font-size: clamp(12px, 0.729545vw, 16px);
    padding-top: 9px;
    border-radius: 7px;
}
.btn-dark-appli {
    font-size: 16px !important;
    padding-left: 26px !important;
    padding-right: 26px !important;
    height: 38px !important;
    line-height: 24px !important;
    border-radius: 8px !important;
    font-weight: 500 !important;
}
.btn-green-appli {
    color: #fff !important;
    background: #46d5b3;
    font-size: 16px !important;
    padding-left: 26px !important;
    padding-right: 26px !important;
    height: 38px !important;
    line-height: 24px !important;
    border-radius: 8px !important;
    font-weight: 500 !important;
    border: solid 1px #46d5b3;
}
.form-control,
.form-select {
    border-radius: 8px;
    height: 40px;
    /*padding-top: 8px;*/
    font-size: clamp(12px, 0.729545vw, 16px);
}
.rest-du {
    background: #7d2dbd;
    border-radius: 4px;
    padding: 5px 12px;
    height: 32px !important;
}
.box-amount {
    font-weight: 400px;
    font-size: 12px;
    padding: 2px 17px;
    border-radius: 4px;
    background: #46d5b3;
    color: white;
}
.some-amount {
    border: solid 1px #7b8289;
    border-radius: 8px;
    padding: 4px 15px;
    width: 90%;
    margin-bottom: 25px;
    overflow: auto;
}
.title-some-am {
    border-bottom: solid 1px #7d2dbd;
    width: 100%;
}
#toggleButton {
    cursor: pointer;
    transition: transform 0.3s;
}
.disable-focus:focus {
    border-color: none !important;
    box-shadow: none !important;
}
.fidelity-desg {
    border-radius: 8px 0px 0px 8px;
    background: transparent !important;
    border-right: 0 !important;
    height: 40px;
}
.euro-desg {
    border-radius: 0px 8px 8px 0px !important;
    background: #f8fafc !important;
    border: 1px solid #e2e8f0;
    border-left: 0;
    line-height: 24px;
    color: #94a3b8 !important;
    height: 40px;
}
</style>
